/**
 * Page Backgrounds Configuration
 * Constants and options for the page backgrounds management
 */

const backgroundsConfig = {
  // Available button styles for home page banner
  // These match the CSS classes used on the ecommerce frontend
  buttonStyles: [
    {
      value: 'white-trans-btn-with-white-border',
      label: 'Transparent with White Border',
      description: 'Transparent background with white text and border',
    },
    {
      value: 'white-btn',
      label: 'Solid White',
      description: 'Solid white background with dark text',
    },
  ],

  // Recommended image sizes
  imageSizes: {
    home: { width: 1920, height: 800 },
    'product-listing': { width: 1920, height: 600 },
  },

  // Validation rules (matching backend API)
  validation: {
    imageUrl: {
      required: true,
      maxLength: 500,
    },
    description: {
      required: false,
      maxLength: 1000,
    },
    title: {
      required: false,
      maxLength: 255,
    },
    subtitle: {
      required: false,
    },
    buttonText: {
      required: false,
      maxLength: 100,
    },
    buttonLink: {
      required: false,
      maxLength: 500,
    },
    buttonStyle: {
      required: false,
      maxLength: 100,
    },
    readMoreContent: {
      required: false,
      maxLength: 500,
    },
  },
};

// Helper to get button style by value
export const getButtonStyleLabel = (value) => {
  const style = backgroundsConfig.buttonStyles.find((s) => s.value === value);
  return style ? style.label : value;
};

// Helper to get button style description
export const getButtonStyleDescription = (value) => {
  const style = backgroundsConfig.buttonStyles.find((s) => s.value === value);
  return style ? style.description : '';
};

// Helper to check if a button style is valid
export const isValidButtonStyle = (value) => {
  if (!value) return true; // Optional field
  return backgroundsConfig.buttonStyles.some((s) => s.value === value);
};

// Helper to get recommended size for a page
export const getRecommendedSize = (page) => {
  return backgroundsConfig.imageSizes[page] || backgroundsConfig.imageSizes.home;
};

export default backgroundsConfig;
